module.exports = __webpack_public_path__ + "7d2bcca7168a5b34537cb7861343f012.png";